// src/components/Quotation/QuotationTotalSummary.jsx
import React from "react";

const Row = ({ label, value, bold }) => (
  <div style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderBottom: "0.5px solid #F3F4F6" }}>
    <span style={{ fontSize: 13, color: bold ? "#111827" : "#6B7280", fontWeight: bold ? 600 : 400 }}>{label}</span>
    <span style={{ fontSize: 13, fontWeight: bold ? 700 : 500, color: bold ? "#1A56DB" : "#111827" }}>₹{value ?? 0}</span>
  </div>
);

const QuotationTotalSummary = ({ total }) => {
  if (!total) return null;
  return (
    <div style={{ background: "#F9FAFB", borderRadius: 12, padding: "16px 20px", maxWidth: 360, marginLeft: "auto" }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: "#111827", marginBottom: 10 }}>Summary</div>
      <Row label="Total Qty"           value={total.totalQty} />
      <Row label="Total Amount"        value={total.totalAmount} />
      <Row label="Total Discount"      value={total.totalDiscount} />
      <Row label="Taxable Value"       value={total.totalTaxableValue} />
      <Row label="Total CGST"          value={total.totalCGSTAmount} />
      <Row label="Total SGST"          value={total.totalSGSTAmount} />
      <Row label="Total IGST"          value={total.totalIGSTAmount} />
      <Row label="Tax Amount"          value={total.quotationTotalTaxAmount} />
      <Row label="Total After Tax"     value={total.quotationTotalAfterTax} bold />
    </div>
  );
};

export default QuotationTotalSummary;
